import {TranslateServiceForm} from './../translate'; // import our opaque token
import {StringUtil, CommonUtil} from './'; // import our opaque token

export class MessageUtil {

    constructor(private _translate : TranslateServiceForm) {

    }
    public convertMsg  (type:string, key:string) : string {
        return this._translate.instant(type + '_' + key);
    }

    public convertMessage (message:string) : string {
        var returnHtml = this._translate.instant('ACTION_'+message);
        if(returnHtml == "NONE") {
            if(message == "AL_policyApplyFail") {
                return this._translate.instant('AL_policyApplyFail');
            } else {
                return message;
            }
        } 
        return returnHtml;
    }

    public convertResult(obj:any) : string {
        var value = obj.result;
        var returnHtml = value;
        if(StringUtil.startWith(value, 'RESULT_') || StringUtil.startWith(value, 'ERROR_')) {
            returnHtml = this._translate.instant(value);
        } else if (obj.name == 'AL_policyApplyFail') {
            var convertedmsg = "";
            var tokens = obj.result.split(",");
            for( var i=0; i<tokens.length ; i++ ){
                convertedmsg += ((this._translate.instant(tokens[i]) === 'NONE')? tokens[i] : this._translate.instant(tokens[i])) + ", ";
            }
            returnHtml = convertedmsg;
        } else {
           returnHtml = (this._translate.instant(value) === 'NONE')? value : this._translate.instant(value);
        }
        
        return returnHtml;
    }

    public convertStatus(rowData:any, type?: string | string[]) : string {
        var returnHtml = null;
		var value = rowData.status;
        if (type == "main") {		
            if(rowData.status == 'OPENED'){
                var buttonText = this._translate.instant("handleIssue");
                if (rowData.logClass != null && rowData.logClass !== "") {
					returnHtml = "<span style='color:#ff6600'>"+ CommonUtil.cutByte(buttonText, 7) + "</span>";
				} else {
					returnHtml = "<span style='color:#ff6600'>"+ this.convertMsg('Status', value) + "</span>";
				}
            } else if(rowData.status == 'FIXED') { 
                returnHtml = "<span style='color:#ff6600'>"+ CommonUtil.cutByte(this._translate.instant('handleClose'),7) + "</span>";
            } else {
				returnHtml = this.convertMsg('Status', value);
			}
        } else if (type == "popup") {
            if(rowData.status == 'OPENED'){
                var buttonText = this._translate.instant("handleIssue");
                // 리스트로 불러온 logClass 와 상세정보로 불러온 logClass 가 다름 ( null 과 empty )
				if(rowData.logClass == null || rowData.logClass.code == null || rowData.logClass.code == '') {
					buttonText = this.convertMsg('Status', value);
				}
				returnHtml = "<span style='color:#ff6600'>"+ buttonText + "</span>";
            } else if(rowData.status == 'FIXED') {
                returnHtml = "<span style='color:#ff6600'>"+ this._translate.instant('handleClose') + "</span>";
            } else {
                returnHtml = this.convertMsg('Status', value);
            }
        } else {	
            if (rowData.status == 'OPENED') {
                let buttonText = this._translate.instant("handleIssue");
                if (rowData.logClass != null && rowData.logClass !== "") {
					/*let buttonHtml = "<button type='button'>"+buttonText+"</button>";*/
					let buttonHtml = "<a class='btnA'>"+buttonText+"</a>";
					returnHtml = buttonHtml;
				} else {
					returnHtml = this.convertMsg('Status', value);
				}
            } else if (rowData.status == 'FIXED') {
				/*let buttonHtml = "<button type='button'>"+this._translate.instant('handleClose')+"</button>";*/
				let buttonHtml = "<a class='btnA'>"+this._translate.instant('handleClose')+"</a>";
				returnHtml = buttonHtml;
            } else {
                returnHtml = this.convertMsg('Status', value);
            }
        }
        return returnHtml;
    }

}


// WEBPACK FOOTER //
// ./src/app/utility/MessageUtil.ts